if (!customElements.get("low-power-video")) {
  customElements.define(
    "low-power-video",
    class LowPowerVideo extends HTMLElement {
      constructor() {
        super();
        this._boundHandlers = [];
      }

      connectedCallback() {
        this.video_section = this.querySelector(".wt-video");
        this.video_background_section = this.querySelector(".hero--video-background");

        if (this.video_section) {
          this.setupToggleForVideoSection(this.video_section);
        }

        if (this.video_background_section) {
          this.setupToggleForBackgroundVideo(this.video_background_section);
        }

        // Setup wrapper controls
        this.videoWrappers = this.querySelectorAll(".rf-video-wrapper");

        this.videoWrappers.forEach((wrapper) => {
          const video = wrapper.querySelector("video");
          const playBtn = wrapper.querySelector(".rf-video-btn--play");
          const pauseBtn = wrapper.querySelector(".rf-video-btn--pause");

          if (!video) return;

          video.setAttribute("playsinline", "");
          video.setAttribute("webkit-playsinline", "");

          if (!video.getAttribute("preload")) {
            video.preload = "metadata";
          }

          this.setupPlayPauseButtons(wrapper, video, playBtn, pauseBtn);
        });
      }

      async attemptPlay(video) {
        if (!video) return false;

        try {
          await video.play();
          return true;
        } catch (err) {
          try {
            video.muted = true;
            await video.play();
            return true;
          } catch (err2) {
            console.warn("Video play failed:", err2);
            return false;
          }
        }
      }

      setupPlayPauseButtons(wrapper, video, playBtn, pauseBtn) {
        const setPlayingUI = (isPlaying) => {
          if (!wrapper) return;

          if (isPlaying) {
            wrapper.classList.add("is-playing");
            playBtn?.classList.remove("visible");
            pauseBtn?.classList.add("visible");
          } else {
            wrapper.classList.remove("is-playing");
            playBtn?.classList.add("visible");
            pauseBtn?.classList.remove("visible");
          }
        };

        video.addEventListener("play", () => setPlayingUI(true));
        video.addEventListener("pause", () => setPlayingUI(false));
        video.addEventListener("ended", () => setPlayingUI(false));

        // Initial state
        setPlayingUI(!video.paused && !video.ended);

        if (playBtn) {
          playBtn.addEventListener("click", (e) => {
            e.stopPropagation();
            this.attemptPlay(video);
          });
        }

        if (pauseBtn) {
          pauseBtn.addEventListener("click", (e) => {
            e.stopPropagation();
            video.pause();
          });
        }
      }

      setupToggleForVideoSection(video_section) {
        const video_element = video_section.querySelector("video");
        if (!video_element) return;

        video_element.setAttribute("playsinline", "");
        video_element.setAttribute("webkit-playsinline", "");

        const toggleHandler = async (e) => {

          // Prevent toggle when clicking controls or wrapper
          if (
            e.target.closest(".rf-video-btn") ||
            e.target.closest(".rf-video-controls") ||
            e.target.closest(".rf-video-wrapper")
          ) {
            return;
          }

          if (video_element.paused || video_element.ended) {
            await this.attemptPlay(video_element);
          } else {
            video_element.pause();
          }
        };

        // video_section.addEventListener("click", toggleHandler);
        // video_section.addEventListener("touchstart", toggleHandler);

        this._boundHandlers.push({
          el: video_section,
          handler: toggleHandler,
        });
      }

      setupToggleForBackgroundVideo(video_background_section) {
        const hero_overlay = video_background_section.querySelector(".hero__overlay");
        const video_element = video_background_section.querySelector("video");

        if (!video_element || !hero_overlay) return;

        video_element.setAttribute("playsinline", "");
        video_element.setAttribute("webkit-playsinline", "");

        const toggleHandler = async (e) => {

          // Prevent toggle when clicking controls or wrapper
          if (
            e.target.closest(".rf-video-btn") ||
            e.target.closest(".rf-video-controls") ||
            e.target.closest(".rf-video-wrapper")
          ) {
            return;
          }

          if (video_element.paused || video_element.ended) {
            await this.attemptPlay(video_element);
          } else {
            video_element.pause();
          }
        };

        // hero_overlay.addEventListener("click", toggleHandler);
        // hero_overlay.addEventListener("touchstart", toggleHandler);

        this._boundHandlers.push({
          el: hero_overlay,
          handler: toggleHandler,
        });
      }

      disconnectedCallback() {
        this._boundHandlers.forEach((item) => {
          try {
            item.el.removeEventListener("click", item.handler);
            item.el.removeEventListener("touchstart", item.handler);
          } catch (e) {}
        });

        this._boundHandlers = [];
      }
    }
  );
}